<h2 mat-dialog-title>Escolher formato de contagem/digitação</h2>

<mat-dialog-content>
  <p class="subtitle">{{ data.totalProdutos }} produto(s) filtrado(s). Escolha uma das opções abaixo para continuar.</p>

  <div class="action-card-grid">
    <button type="button" class="action-card-action" (click)="escolher('imprimir')">
      <app-action-card
        icon="print"
        title="Imprimir lista para contagem"
        description="Imprima a relação dos produtos para realizar a contagem física manualmente e depois registrar os dados em uma nova digitação de inventário."
        [interactive]="true">
      </app-action-card>
    </button>

    <button type="button" class="action-card-action" (click)="escolher('exportar')">
      <app-action-card
        icon="table_view"
        title="Exportar para planilha para contagem"
        description="Baixe os produtos em formato CSV, preencha as quantidades contadas offline e importe depois pela rotina de importação via planilha."
        [interactive]="true">
      </app-action-card>
    </button>

    <button type="button" class="action-card-action" (click)="escolher('digitar')">
      <app-action-card
        icon="edit_note"
        title="Iniciar digitação do inventário"
        description="Inicie agora a digitação do inventário com os produtos filtrados já pré-carregados. Você precisará apenas informar o nome do inventário."
        [interactive]="true">
      </app-action-card>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" mat-dialog-close>Cancelar</button>
</mat-dialog-actions>
